import React, { useEffect, useState } from "react";
import { Form, Input, Button, Tooltip, Modal, Spin, Checkbox } from "antd";

import "antd/dist/reset.css";
import "../../assets/css/login.css";
import ForgotPassword from "./ForgotPassword";
import { useDispatch, useSelector } from "react-redux";
import { login, authState } from "../../features/auth/authSlice";
import initAmplify from "../../Config/aws-exports";
import ResetPassword from "./ResetPassword";

export default function Login() {
  const [forgotModal, setForgotModal] = useState(false);
  const { isLoading, error, resetPasswordCodeSend } = useSelector(authState);
  const dispatch = useDispatch();

  useEffect(() => {
    initAmplify();
  }, []);

  const onFinish = async (values) => {
    dispatch(login(values));
  };

  return (
    <div className="join-pop-up">
      <div className="container-auth">
        {isLoading && (
          <div className="loginLoader">
            <Spin size="medium" />
          </div>
        )}
        <div className="Sign-into-SkillGigs">Sign In to SkillGigs</div>
        <Form name="normal_login" className="login-form" onFinish={onFinish}>
          <Form.Item
            name="email"
            hasFeedback
            rules={[
              {
                type: "email",
                message: "email is not Valid!",
              },
              {
                required: true,
                message: "Please add your email address",
              },
            ]}
          >
            <Input placeholder="Enter your email" id="validating" />
          </Form.Item>
          <Form.Item
            name="password"
            hasFeedback
            rules={[
              {
                pattern: /^\S{8,}$/,
                message: "please use a valid password",
              },
              {
                required: true,
                message: "Please add your password",
              },
            ]}
          >
            <Input.Password
              className={`passwordSignUp`}
              placeholder="Password"
              iconRender={(visible) =>
                visible ? (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#007cf0",
                      cursor: "pointer",
                    }}
                  >
                    Hide
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 500,
                      color: "#007cf0",
                      cursor: "pointer",
                    }}
                  >
                    Show
                  </span>
                )
              }
            />
          </Form.Item>
          {error && (
            <div
              className={
                "ant-form-item-explain ant-form-item-explain-connected"
              }
            >
              <div role="alert" className={"ant-form-item-explain-success"}>
                <div className={"notValidColor"}> {error} </div>
              </div>
            </div>
          )}
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Sign In
            </Button>
          </Form.Item>
          <div className="rememberBox">
            <div>
              <Form.Item name="remember" valuePropName="checked" noStyle>
                <Checkbox>
                  <div className="remeberForgotCSS">
                    <span>Remember me</span>
                  </div>
                </Checkbox>
              </Form.Item>
            </div>
            <div className="ForgottPassword">
              <span
                onClick={() => {
                  setForgotModal(true);
                }}
              >
                Forgot Password?
              </span>
            </div>
          </div>
        </Form>
        <Modal
          width="24.37rem"
          closable={false}
          open={forgotModal && !resetPasswordCodeSend}
          footer={null}
          onCancel={() => {
            setForgotModal(false);
          }}
        >
          <ForgotPassword />
          <div className="authDivider"></div>
          <div
            className="bottom-text"
            onClick={() => {
              setForgotModal(false);
            }}
          >
            Back to Sign In
          </div>
        </Modal>

        <Modal
          width="24.37rem"
          closable={false}
          open={resetPasswordCodeSend}
          footer={null}
          onCancel={() => {
            // setResetModal(false);
          }}
        >
          <ResetPassword />
          <div className="authDivider"></div>
          <div
            className="bottom-text"
            onClick={() => {
              setForgotModal(false);
            }}
          >
            Back to Sign In
          </div>
        </Modal>
        
      </div>
    </div>
  );
}
